import { config } from '@uhg-abyss/web/tools/config';
import { getError } from '../../tools/http';

export const userApiError = (res) => {
  const responseData = res.data || {};
  const errorData = getError(
    { ...res, requestId: res.config.id },
    config('CORE_LAGOON_CONFIG_MANAGER')
  );

  return {
    ...res,
    data: {
      ...responseData,
      ...errorData,
    },
    isUserApiError: true,
  };
};

export const userAdminError = async (res) => {
  const errData = await getError({ ...res, requestId: res.config.id }, true);
  return {
    ...res,
    data: {
      ...res.data,
      adminErrCode: res.data.error.code,
      adminErrMessage: errData.message,
    },
  };
};
